export const LINE_HEIGHT = 18;
export const DEFAULT_MIN_HEIGHT = 274;
export const BOTTOM_WRAPPER_PADDING = 26;
